import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

function setDangerousHtml(html, el) {
  if (el === null) return;
  const range = document.createRange();
  range.selectNodeContents(el);
  range.deleteContents();
  el.appendChild(range.createContextualFragment(html));
}
const ParagraphEmbedHtml = ({ entity }) => {
  /* Below we deliberatly use the value here so VNL can use html */
  const body = entity.getIn(['field_body', 0, 'value']);
  const title = entity.getIn(['field_title', 0, 'value'], null);

  return (
    <Container className="Paragraph ParagraphEmbedHtml">
      <div className="row">
        <div className="ParagraphEmbedHtml__inner col-12 col-lg-8 offset-lg-2">
          <h2>{title}</h2>
          <div className="ParagraphEmbedHtml__embed" ref={setDangerousHtml.bind(null, body)} />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphEmbedHtml;
